module.exports = __webpack_public_path__ + "img/14-1_05.0faf5482.jpg";